module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("‘J")])]), _vm._v("ethro! You gave me such a fright.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m sorry, Miss Hester, but I brought in the hampers and I couldn’t see you. I called, then I thought I’d better come and find you.’ He glanced over her shoulder and went pale under the freckles. ‘Gawd, Miss Hester, what’s happened in there?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do not blaspheme, Jethro,’ Hester said automatically, turning to let him see in. ‘I have no idea, but it does not look as if it were anything good.’ She twisted up the nightrail in her hands. Jethro was only a lad for all his size and his growing awareness of girls, and she did not want him seeing that violated, intimate garment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s blood, Miss Hester.’ He was already into the room, his feet crunching on broken glass and leaving clear tracks through the undisturbed dust.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, no, please, not that.’ Hester followed him more cautiously and stared at the brown splashes on the wall. ‘It is not so very much. Perhaps it is red wine, or maybe whoever broke the mirror cut himself?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("‘That’ll be it, no doubt about it, Miss Hester,’ Jethro said comfortably. He was not as innocent as his young mistress ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("thought him and the images that came to his mind when he saw the room chimed very much with hers. ‘It’ll have been burglars, to be sure,’ he continued, walking firmly out so Hester had to give way in front of him. ‘Throwing all the doors open and knocking things around when they found the cupboards empty, I’ll be bound.’")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shut the door. ‘Will this be your room, Miss Hester?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes…’ Hester heard the hesitation in her own voice and said firmly, ‘Yes, it will, and Susan can have the one to the right at the top of the stairs. I expect Miss Prudhome will like one of the rooms at the back.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The unconscious glance she cast at the dressing-room door was not lost on the boy. ‘I’ll sweep those rooms out then, shall I, after luncheon, and light the fires? Then I can bring the bags up without your things getting dusty.’ And there was a pot of whiting in the stables, he could soon mix some whitewash up and cover that stain, she’d feel better about the room with that gone and the broken things tidied away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The rooms over the stables are right and tight, Miss Hester,’ he continued, firmly leading the way downstairs. ‘There’s a pot-bellied stove, so I’ll be snug as a bug in there.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That is good news, Jethro,’ Hester said briskly. Everything was perfectly all right, except for that disturbing room. Try as she might, she could not believe Jethro’s explanation of burglars. The thick carpet of dust had been even, as though it had been left undisturbed as a whole. Surely the intruders’ footprints would have shown, even through the later falls? And why would burglars tear a nightgown or break a valuable string of pearls and leave them?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I was going to run over to the inn to order a cask of ale, Miss Hester. Do you want me to wait until the others get here?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("‘No, the ale is a good idea and you may as well go now. Goodness knows how long it will take them to get here from ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("King’s Langley if Miss Prudhome’s persuaded the postilion to go slowly the entire way.’")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shot her an anxious look, but took the coins she handed him and went out. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Of course it is all right being here alone")]), _vm._v(", Hester told herself firmly. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What are you afraid of? Ghosts?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her stomach rumbled at that point, effectively putting paid to all thoughts of spectres or earls. What time was it? The old longcase clock in the kitchen had last been wound years ago, but her pocket watch said clearly that it was two of the clock and that breakfast at the inn at King’s Langley where they had stayed overnight was many hours away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jethro had thoughtfully drawn a bucket of water, which stood in the slate-lined sink. Hester dipped some out into a bowl, found an ancient scrubbing brush on the window ledge and attacked the kitchen table. It would need hours’ more work before it became white again, but at least they could eat luncheon off it without a qualm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She spread a cloth from the top of one of the hampers, found bread, cheese, a jar of pickles and a packet of butter, then turned her attention to the contents of the kitchen cupboards.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jethro returned after half an hour with a vast earthenware pitcher of ale, heavy enough to make him gasp with relief when he set it down on the table. ‘That’s a ploughman’s pot, that is,’ he remarked, mopping his brow. ‘Part of the ploughman’s wages is his daily ale and his lad goes to fetch it for him. Often as not he’ll empty it down, then break it on the plough handles and send the boy back for another one with a cuff on the ear for being so careless.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester put down the stack of plates she had been scouring in cold water and regarded him, head on one side. ‘That is interesting, Jethro. How did you know that?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("‘Don’t remember,’ he muttered, opening the other hamper ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("and starting to lift things out. ‘They’ll send the cask over later today, but I thought we’d need some for now.’")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester sighed. She had found him unconscious in the gutter in Old Holborn over a year ago, starved thin as a rake and with the marks of old beatings on his back. Taken back to the house in Mount Street, he had been quiet, polite and obdurately silent on anything but his name. He attached himself with dogged devotion to Hester and obeyed her in everything but the request to tell of his past. His accent had a burr, which had largely vanished under the influence of London speech and Hester’s cultured tones, but she suspected country origins and that little story seemed to confirm it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Here is some cutlery.’ She pushed it over the table, abandoning any thought of probing further. If and when he wanted to tell her he would do so. She had enough bad memories and secrets of her own not to pry into his.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally they sat down to eat in front of the range, which was slowly beginning to take the chill off the air. Hester put down her ale, which she was drinking out of an earthenware beaker for want of any more suitable vessel, and observed, ‘I hope the glassware arrives safely with Susan. We are having a gentleman caller tomorrow and I must offer wine.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘At least we’ve got some good wine,’ Jethro remarked. The disturbing memory had faded, leaving him bright eyed and interested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, and fortunately I put a few bottles of the Madeira and port into the baggage that is on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise")]), _vm._v(". The rest will be coming with the carrier.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bless John for having left her his wine cellar. An unconventional thing to leave to a woman, but they had enjoyed a glass of wine together so often. Of course, it was only one of the numerous scandalous things that could be laid at her door. And his relatives had not hesitated to enumerate every one.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This time it was Jethro who pulled her out of painful reverie. ‘What gentleman is it, Miss Hester?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No mere gentleman…an earl, no less.’ Hester pushed the card across to him. Jethro read it, eyes wide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You won’t have Susan answering the door, will you, Miss Hester? Not in the afternoon?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, Jethro. A female servant in the afternoon? That would never do.’ Hester repressed a smile. ‘I shall require you to put on your best suit and be the butler.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His wide grin was not in the slightest reduced by the intelligence that, as well as setting the bedchambers and kitchen to rights today, they must all work tomorrow to clean the hall and make one of the front reception rooms decent before their visitor arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It will take all the furniture we can find to furnish up the one room.’ Hester bit her lip thoughtfully. ‘The carrier’s cart will not arrive tomorrow and what there is here is sparse, to put it mildly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And old-fashioned.’ Jethro’s ambitions in life caused him to be surprisingly aware of such details.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Good quality, though, and very feminine. Perhaps the last person to live here was an elderly single woman, or a widow.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Further speculation was cut short by the arrival of the post "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise")]), _vm._v(" in the yard. Susan Wilmott—plump, good natured and just now looking delighted to have arrived—jumped down and held up her hands to assist an older woman. Miss Prudhome, Hester’s companion of two weeks’ standing, and decidedly green in the face, tottered from the vehicle and into Hester’s arms. ‘Never again, Hester dear, not if I have to walk a hundred miles! Never again in one of those yellow bounders.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There, there.’ Hester patted her back while trying to ignore the postilion’s rolling eyes. ‘You made very good time considering,’ she added placatingly to the man. ‘Jethro, show the postilion where he can water his horses while we unload the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise")]), _vm._v(".’")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester placed her companion firmly in a chair in the kitchen with a glass of water and joined her two staff to bring in the contents of the post "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Susan dumped an armload on the table and looked around her with interest. ‘Nice house, Miss Hester, but it’s awful big for just two staff. Are you going to hire in anyone else?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I hope so, Susan.’ Hester lowered her end of a hamper of house wares. ‘But I need to find out how much I must spend to get the house in order first and then I will see what we can afford. Until then we will just keep the downstairs and three bedchambers in order.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now, you find yourself some luncheon and then we will decide what to do first.’ She regarded Miss Prudhome dubiously. ‘Do you think you could manage a little luncheon, Prudy?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A pitiful groan greeted the question. Miss Prudhome was thin, forty-eight years of age and, Jethro was unkind enough to remark, closely resembled a hen. ‘One of those worried-looking brown ones, you know, Miss Hester.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester did know, and unfortunately could not get the image out of her head whenever she looked at her recently engaged companion with her pointed nose and anxious little eyes behind precarious "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pince-nez")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was, in fact, a governess but, as Hester’s limited budget had ruled out all the superior companions who presented themselves in answer to her advertisement, she was the only affordable candidate. Her halting tale of being dismissed from her employment of ten years because the youngest boy had gone to school wrung Hester’s kind heart and she had accepted her application against her better judgement. She had even yielded to Miss Prudhome’s wistful request that she call her ‘Prudy’.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jethro marched in, arms loaded with broom, mop and bucket and clanked past. ‘I’ll just get the worst of the mess sorted upstairs, Miss Hester, and light the fires.’")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By seven o’clock the four of them were collapsed in a semi-circle of chairs by the range, which Jethro had managed to keep going, although with an ominously smoky chimney. ‘Full of nests, I guess,’ he observed. ‘I’d better find a sweep tomorrow and have all the fires done.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Never mind,’ Hester said cheerfully. ‘We each have a comfortable bed to sleep in and a clean kitchen to cook and eat in. And tomorrow we can see to the hall and front room.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Prudy twittered nervously, Susan sighed gustily and even Jethro looked a little daunted, presumably at the thought of all the other rooms, to say nothing of the garden, the stable yard and the outbuildings. But Hester felt nothing but peace and a sense of home. If she had been a cat she would have turned round several times and curled up in front of the fire with her tail over her nose; as it was she got to her feet, rolled up her sleeves and reached for a saucepan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Dinner and bed for all of us. If we do not eat soon, we will be beyond it,’ she said bracingly. ‘You peel the potatoes, Jethro. Susan, shred some of that cabbage and slice the onions and I will fry up those collops of veal. Prudy, please lay the table and put some bricks in the lower oven to warm up for the beds.’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The meal was good, filling and savoury, and the eyes of her three companions were soon drooping. Hester sent Susan and Prudy to bed, each clutching a flannel-wrapped brick, assuring them she had no further need of them that night, and even Jethro was persuaded to take himself and his lantern off to his bed over the stables after faithfully checking the windows and front door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester twisted the key in the back door after him, dragged the bolts across and gave the fire a final riddle before taking a chamber stick and making her way through the now-silent house.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The darkness closed in behind her softly like a velvet curtain as she climbed the stairs. There was no light from the other rooms. She hesitated on the threshold of her chamber, her eyes on the door leading to the dressing room. In the firelight it seemed to move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The silence enclosed her, friendly no longer. ‘No,’ Hester said firmly. ‘This is my room and I am not going to be frightened by some broken glass and a stain on the wall.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She marched over to the table by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise-longue")]), _vm._v(" and lit the candles in the three-branched stick that stood on it. Her own face reflected in the panes of glass in the unshuttered windows. It was the dark of the moon and only lights from the houses and cottages around the Green punctuated the night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she tried to pull the silk curtains closed they crumbled in her hands, rotten from years of neglect. On one window the shutters unfolded and closed easily enough, but on the other they would not shift, even at the cost of a broken fingernail. Hester shrugged; she would undress on the screened side of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In her nightrail and shawl she bent to blow out the branched candlestick and found herself staring at that door again. Was she going to sleep or was she going to lie awake, staring at it in the dark and imagining goodness knows what?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Slowly Hester walked towards it, the single chamber stick in her hand, and finally turned the handle. ‘Oh, bless the boy!’ Jethro had swept and dusted. The glass was gone, the stained patch of wall gleamed newly white. The pearls had been collected up into a bowl on the dressing table and the doors of the presses were shut. He had even opened the window an inch and the chill air had driven away the musty smell. It was an empty, unthreatening room once more. He was a good lad, sensitive beyond his years sometimes. Hester smiled, recalling John’s doubts when she had returned home with her filthy ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("waif. ‘You will regret it,’ he said, studying the lad with a cynical soldier’s eye, but she never had.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She drifted back to bed, reassured and suddenly too tired either to plan or to remember. As she snuggled under the sheets her thoughts flickered to tomorrow’s encounter. What would the earl think of her? she wondered. Strange that it was not his wife who had made the first call. Perhaps he was unmarried…")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester slept. Across the road in the red brick house Guy Westrope stood in his dark bedchamber, the book he had strolled upstairs to fetch in his hand. He could see in the dark uncannily well and had not troubled to pick up the branch of candles from the landing table when he entered. Now he stood waiting to see whether that slender ghost of a figure in white would cross the room opposite his again. But the window in the Moon House went dark as a candle was extinguished.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Who was she? Not that quaint maid, not in what must be the best bedchamber. The lady of the house? Or simply a phantom of his imagination? No, not that, for the ghost he would expect to conjure up would have blonde hair, not a tumbling mass of brunette curls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cursing himself for a fool, not for the first time that day, Guy strode out of the room and downstairs to a solitary meal. The most entertainment he could hope for would be his attempts to catch his butler Parrott betraying by so much as a quiver his utter disapproval of the village, the house and the entire enterprise. His valet was far more vocal on the subject and on the ruination of his hopes of seeing his master outshining every guest at Major Carew’s house party. Guy smiled grimly: he was an extremely generous and considerate employer, but he was not going to be criticised by his own staff for whatever whim he chose to indulge. In this particular case he could do that quite effectively himself.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At ten to three the next afternoon Hester called her household into the newly garnished reception room and surveyed both it and them. They had scoured the room clean and then stripped the house of suitable furnishings. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise-longue")]), _vm._v(" from her bedroom, a dresser from the other front chamber and side tables from all over dressed the room and a large, if smoky, fire blazed on the hearth. There were two imposing armchairs, which she placed one each side of the fireplace, and a chair set to one side for Prudy to sit upon. It looked a little like a rented room in an unfashionable part of town, but it would have to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least she and her staff were suitably clad to receive a caller: Jethro in his best dark suit with horizontally striped waistcoat, his hair neatly tied back, Susan in a respectable dimity and Prudy looking every bit the governess in sombre grey with a black knitted shawl. For herself Hester had chosen a gown of fine wool in a soft old gold colour, with a fichu edged with some of the good lace she had inherited from her mother and her best Paisley shawl. Her hair was ruthlessly confined in its net at the back with just a few soft curls at the temples and forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester gave her hem one last anxious twitch. ‘I think we look admirably respectable,’ she announced firmly. It was the impression she was striving for, the impression it was essential to convey if she was to hope to have any kind of social life in the village or nearby towns. It was odd enough for a young lady of four and twenty to live alone save for a companion, but to produce the slightest suspicion of anything ‘not quite the thing’ would be fatal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("The effort it had taken to transform the front room and the hall had succeeded in distracting her from the nagging feeling that she might already have sunk herself beneath reproach ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("when she answered the door to the earl yesterday. But now it returned. Would he be very affronted when he realised who the maid was? Or, even worse, would he consider it a great joke to be spread around his acquaintance? Being thought to be eccentric was not Hester’s ambition either.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was most certainly prompt. Hester had hardly settled herself before the fireplace with a piece of embroidery in her hand when the knocker sounded. Jethro tugged down his coat, straightened his face and strode out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was the sound of voices in the hall, then Jethro reappeared. ‘The Earl of Buckland, Miss Lattimer.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester rose to her feet, put down her embroidery, looked up and felt her breath catch in her throat. Somehow she retrieved enough of it not to croak as she stepped forward with outstretched hand. ‘Good afternoon, my lord. I am Hester Lattimer.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How could she not have realised yesterday? Had she been so overwhelmed by the house, so frightened by his sudden knocking? The man standing in front of her was not just extremely attractive—quite simply, he was her ideal. She had no need to do more than to look into those dark blue eyes with their crinkle of laughter lines at the corners, the lurking mixture of intelligence, humour and frank admiration in their depths, to feel a surge of heat in her blood and an indefinable sense of recognition.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took her hand and her pulse began to thud so that she thought he must have felt it as he touched her. Hastily she retrieved her hand. ‘My lord, may I make known to you my companion, Miss Prudhome?’ He inclined his head with a smile and Prudy produced a gawky curtsy and an unintelligible twitter. Hester sighed inwardly and gestured towards the other chair. ‘Please, my lord, will you not sit down?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Goodness, he was tall, and broad and…male. Not good looking, she decided, for his nose had definitely been broken, ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("the planes of his face were strong rather than beautiful, his dark blond hair was too long…")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Harrumph.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester started. How long had she been staring at her visitor? Not too long, surely, for he did not appear discommoded. Jethro was standing by the door, looking abashed. His intended quiet throat-clearing had emerged as rather more of a foghorn than a tactful signal from a butler.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ackland, please fetch us some refreshment. Would you care to take tea, my lord? Or perhaps some Madeira?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Tea would be delightful, thank you, Miss Lattimer.’ She nodded to Jethro, who effaced himself silently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The earl’s voice exactly suited him, she decided. So often a voice was a sad disappointment, but his was deep, pleasant and carried a hint of authority. He was watching her with composure, those blue eyes resting on her face, betraying no sign that he recognised her from the day before. To refer to it or not? Suddenly Hester felt she would make herself ridiculous in his estimation if she was missish about this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am sorry I could not receive you yesterday when you called,’ she began. ‘We had only just arrived and it was necessary to do more than I had anticipated to set the house to rights.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My sister frequently tells me that the servant shortage is a difficulty,’ he observed urbanely. Yes, no doubt about it, he did recognise her as that dishevelled ‘maid’.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, it is not that, my lord. I have chosen to bring only a skeleton staff from London and I will hire locally. But just now we are a small household.’ Hopefully that sounded as though she was used to commanding a staff of four times the number.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But, until then, it is intolerable to have to put up with cobwebs?’ The corner of his mouth quirked and Hester could feel her own twitching in response. There was nothing for it but to be frank and trust to his goodwill.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Indeed. It was most remiss of me to have opened the door without thinking. Goodness knows what you must have thought.’ Now that was a foolish thing to have said, inviting him to agree with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I thought that the new arrival in the village had excellent taste in domestic servants.’ Now what did he mean by that? Surely not that he considered her attractive? She found she had no objection to the earl holding that opinion, but for him to say so was the outside of enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I should have called my butler,’ she said repressively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Your butler? Surely you do not mean that youth who showed me in?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But certainly, my lord. I should tell you that Ackland has the intention to become the best butler in England,’ Hester retorted warmly as the door opened. ‘Ah, thank you, Ackland, please put the tray here. I was just telling his lordship that you have great ambitions to rise in your profession.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘To be the best butler in England, I understand.’ The earl half-turned in his seat to regard the gangling youth, showing no sign he had noticed the freckles, the pimples or the fact that the coat sleeves were already half an inch too short. Hester, who had been holding her breath, expecting him to snub the lad and wishing she had kept her mouth shut, could have kissed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, my lord.’ Jethro blushed, but managed to keep his face and voice in order.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, Ackland, I have to tell you that the best butler in England is Mr Parrott and he is in my employ.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Here, my lord? In this village?’ Now he sounded fourteen and not the seventeen Hester guessed him to be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Certainly he is here. I shall mention you to him; perhaps one day, when he is not too busy, he will unbend enough to give you some advice on your chosen profession.’")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jethro had gone so white Hester was certain he was about to swoon. ‘That is most kind of his lordship, Ackland. You may go now.’ Bless him, his feet would not touch the ground for a week.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" most kind of you, my lord,’ she said as the door closed behind the youth. ‘He is so very serious about this, despite his age. A single lady’s household is no training ground for him and I suppose he should be seeking a footman’s post as a start.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But you need him here,’ the earl said with a smile. ‘Let us see what Parrott advises.’ He saw the question in her eyes and nodded. ‘Yes, I will make sure he spends some time with the lad.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester poured the tea and wondered when her visitor was going to broach the reason for his call. Surely it was not purely social? ‘Is the countess with you, my lord?’ she enquired, passing the tea cup.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My mother died some months ago.’ Her eyes must have flickered over the dark blue long-tailed coat he wore, for he added, ‘She abhorred mourning, so after the first month we all left it off. I do not feel that wearing unrelieved black for months on end helps one remember the departed any more fondly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, indeed,’ Hester agreed. ‘I myself—’ She broke off. This was one area she did not wish to explore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You have suffered a recent loss too?’ His voice was sympathetic and she almost said more than she should.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes. I was a companion to an invalid for almost two years. The end was not unexpected.’ If that left the false impression that she had been the companion to an elderly lady, then so much the better.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It does not lessen the loss.’ He put down his cup and saucer and recrossed his long legs. ‘That was most refreshing. Miss Lattimer, I cannot pretend that this is a social call; I wish to discuss with you a matter of business.’")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Business?’ Hester made no effort to hide her surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps I should address myself to your man of affairs? If you would give me his direction, I will be happy to do so, although I feel this is a matter upon which he would immediately have to consult you in any case.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then perhaps you can broach the matter and I will refer you to him if necessary.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Very well. Miss Lattimer, I wish to purchase your house.’")])])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page35"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65bce4f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459225107_ch02.vue
// module id = 75
// module chunks = 0